import { Directive, ElementRef, HostBinding, HostListener, Inject, Input } from '@angular/core';
import { SL_ID_PREFIX, SlIdContext } from './sl-id-context';

@Directive({
  selector: '[sl-focus]'
})
export class SlFocusDirective {
  @Input('sl-focus') targetId!: string;

  constructor(private el: ElementRef, private ids: SlIdContext) { }

  @HostListener('click')
  onClick() {
    if (this.targetId) {
      const targetElement = document.getElementById(this.ids.id(this.targetId));
      if (targetElement) {
        const params = {focusVisible: true}
        targetElement.focus(params as any);
        targetElement.dispatchEvent(new CustomEvent('sl-focus', { bubbles: true}));
      }
    }
  }
}
